import { hasValue } from '../helpers'
import { getApiClient } from './apiService'
import config from '../config/env'

const addProduct = async data => {
  try {
    const response = await getApiClient({
      'Content-Type': 'multipart/form-data',
    }).post('/products', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('addProduct error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const updateProduct = async (productId, data) => {
  try {
    const response = await getApiClient({
      'Content-Type': 'multipart/form-data',
    }).post(`/products/${productId}`, data)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('updateProduct error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getProduct = async ({ id }) => {
  try {
    const response = await getApiClient().get(`/products/${id}`)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getProduct error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const searchProducts = async ({
  search = '',
  page = 1,
  city,
  perPage = 12,
}) => {
  let url = `/products/search?q=${search}&page=${page}&per_page=${perPage}`

  if (city) {
    url = `${url}&city=${city}`
  }

  try {
    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('searchProducts error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getProductsByCategory = async ({
  category,
  subcategory,
  city,
  page = 1,
  perPage = 12,
}) => {
  let url = `/products/category?category=${category}&page=${page}&per_page=${perPage}`

  if (hasValue(subcategory)) {
    url = `${url}&subcategory=${subcategory}`
  }

  if (hasValue(city)) {
    url = `${url}&city=${city}`
  }

  try {
    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('searchProducts error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const productService = {
  addProduct,
  updateProduct,
  getProduct,
  searchProducts,
  getProductsByCategory,
}
